// extracted by mini-css-extract-plugin
module.exports = {"injectedHtml":"injected-html-module--injectedHtml--1YwRF"};